import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import * as actions from "../../Store/Actions/index";
import "antd/dist/antd.css";
import "./Home.css";
import "../../custom-antd.css";
import { Menu, List, Button, Row, Col, Spin, Typography } from "antd";
import { MenuUnfoldOutlined, SettingOutlined } from "@ant-design/icons";
import { currencyList } from "../../Util/util";
import { downloadData, uploadData } from "../../Util/dataIO";
import useWindowResize from "../../Util/screenSize";
import RenderCarousel from "../../Components/Elements/Carousel";
import Steps from "../../Components/Elements/Steps";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import store, { persistor } from "../../Store/configureStore";
import { disabledTabIds, disabledShiftTabIds } from "../../Util/dataIO";
import SummaryModal from "../../Components/Pdf/SummaryModal";
import ClearModal from "../../Components/ClearModal/ClearModal";

const { SubMenu } = Menu;
const { Text } = Typography;

const titles = [
  "Introduction",
  "Retraining Costs",
  "Productivity Loss Costs",
  "System Change Costs",
  "Benefits",
  "Adjusted Costs",
  "Summary",
];

const Home = (props) => {
  const width = useWindowResize()[0];
  const stepRef = useRef(props.currentStepStore);

  useEffect(() => {
    window.addEventListener("keydown", keydownListener);
    return () => window.removeEventListener("keydown", keydownListener);
  }, []);

  /**
   * disables default browser interaction for tab press for first (shift tab) or last item on each page
   * @param {*} e - event keypress
   */
  const keydownListener = (e) => {
    if (stepRef.current === 0) {
      if (e.keyCode === 9) {
        e.preventDefault();
      }
    } else {
      const activeElement = document.activeElement;
      if (
        e.keyCode === 9 &&
        ((disabledTabIds.includes(activeElement.id) && !e.shiftKey) ||
          (disabledTabIds.includes(activeElement.parentElement.id) && !e.shiftKey) ||
          (disabledShiftTabIds.includes(activeElement.id) && e.shiftKey) ||
          (disabledShiftTabIds.includes(activeElement.parentElement.id) && e.shiftKey) ||
          activeElement.parentElement.lang)
      ) {
        e.preventDefault();
      }
    }
  };

  const handleMenuClick = (e) => {
    switch (e.key) {
      case "download":
        // call download method
        downloadData();
        break;
      case "upload":
        // call upload method
        uploadData();
        break;
      case "introduction":
        props.setCurrentStepStore(0);
        stepRef.current = 0;
        break;
      case "retrainingCosts":
        props.setCurrentStepStore(1);
        stepRef.current = 1;
        break;
      case "prodLossCosts":
        props.setCurrentStepStore(2);
        stepRef.current = 2;
        break;
      case "systemCosts":
        props.setCurrentStepStore(3);
        stepRef.current = 3;
        break;
      case "benefits":
        props.setCurrentStepStore(4);
        stepRef.current = 4;
        break;
      case "adjustedCostsBenefits":
        props.setCurrentStepStore(5);
        stepRef.current = 5;
        break;
      case "summary":
        props.setCurrentStepStore(6);
        stepRef.current = 6;
        break;
      case "pdf":
        props.setShouldOpenPdfModal(true);
        break;
      case "clear":
        props.setShouldOpenClearModal(true);
        break;
      default:
        break;
    }
  };

  /**
   * @returns the settings menu, which contains currency selection, and upload/download data
   */
  const renderSettingsMenu = () => {
    return (
      <SubMenu icon={<SettingOutlined size="large" />}>
        <SubMenu title="Select Currency" id="currency">
          <List
            style={{ height: 300, overflowY: "auto" }}
            size="small"
            dataSource={currencyList}
            renderItem={(item) => (
              <List.Item
                style={{
                  marginTop: -5,
                  marginLeft: 10,
                  marginBottom: -10,
                  paddingBottom: 0,
                  cursor: "pointer",
                }}
                onClick={() => {
                  props.setCurrency(item);
                }}
              >
                {item}
              </List.Item>
            )}
          />
        </SubMenu>
        <Menu.Item key="download" id="download">
          Download Data
        </Menu.Item>
        <Menu.Item key="upload" id="uplodad">
          Upload Data
        </Menu.Item>
        <Menu.Item key="pdf" id="pdf">
          Results Summary
        </Menu.Item>
        <Menu.Item key="clear" id="clear">
          Clear Input
        </Menu.Item>
      </SubMenu>
    );
  };

  /**
   * @returns the menu to be displayed if the screen width is less than 1500
   */
  const renderSmallMenu = () => {
    return (
      <div className="ant-menu ant-menu-light ant-menu-root ant-menu-horizontal" style={{ backgroundColor: "#c7c8ca" }}>
        <Row>
          <Col flex="80px">
            <Button
              type="primary"
              style={{ width: 80, height: 48 }}
              onClick={() => {
                props.setCurrentStepStore(props.currentStepStore - 1);
                stepRef.current -= 1;
                if (stepRef.current < 0) {
                  stepRef.current = 6;
                }
              }}
              id="prevButton"
            >
              Previous
            </Button>
          </Col>
          <Col flex="128px">
            <Menu
              style={{ backgroundColor: "#c7c8ca", borderWidth: 0 }}
              mode="horizontal"
              selectable={false}
              onClick={handleMenuClick}
            >
              {renderSettingsMenu()}
              <SubMenu icon={<MenuUnfoldOutlined size="large" />}>
                <Menu.Item key="introduction">Introduction</Menu.Item>
                <Menu.Item key="retrainingCosts">Retraining Costs</Menu.Item>
                <Menu.Item key="prodLossCosts">Productivity Loss Costs</Menu.Item>
                <Menu.Item key="systemCosts">System Change Costs</Menu.Item>
                <Menu.Item key="benefits">Benefits</Menu.Item>
                <Menu.Item key="adjustedCostsBenefits">Adjusted Costs</Menu.Item>
                <Menu.Item key="summary">Summary</Menu.Item>
              </SubMenu>
            </Menu>
          </Col>

          <Col flex="auto" style={{ marginRight: width > 620 ? 128 : width > 530 ? 60 : 0 }}>
            {width > 530 && (
              <div style={{ textAlign: "center", fontWeight: "bold" }}>
                <Text>{titles[props.currentStepStore]}</Text>
              </div>
            )}
          </Col>

          <Col flex="80px">
            <Button
              type="primary"
              style={{ float: "right", height: 48, width: 80 }}
              onClick={() => {
                props.setCurrentStepStore(props.currentStepStore + 1);
                stepRef.current += 1;
                if (stepRef.current > 6) {
                  stepRef.current = 0;
                }
              }}
            >
              Next
            </Button>
          </Col>
        </Row>
      </div>
    );
  };

  /**
   * @returns the menu to be displayed if the screen width is greater than or equal to 1500
   */
  const renderLargeMenu = () => {
    return (
      <div style={{ display: "flex", flexDirection: "row", backgroundColor: "#c7c8ca" }}>
        <Menu
          style={{ flex: 1, backgroundColor: "#c7c8ca" }}
          mode="horizontal"
          selectable={false}
          onClick={handleMenuClick}
          id="largeMenu"
        >
          {renderSettingsMenu()}
        </Menu>
        <Steps stepRef={stepRef} />
      </div>
    );
  };

  return (
    <Provider store={store}>
      <PersistGate loading={<Spin size="large" />} persistor={persistor}>
        <React.Fragment>
          {width < 1500 ? renderSmallMenu() : renderLargeMenu()}
          <RenderCarousel />
          <SummaryModal />
          <ClearModal />
        </React.Fragment>
      </PersistGate>
    </Provider>
  );
};

const mapStateToProps = (state) => {
  return {
    currentStepStore: state.status.currentStep,
    shouldOpenPdfModal: state.status.shouldOpenPdfModal,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrency: (currency) => dispatch(actions.setCurrency(currency)),
    setCurrentStepStore: (currentStepStore) => dispatch(actions.setCurrentStep(currentStepStore)),
    setShouldOpenPdfModal: (v) => dispatch(actions.setShouldOpenPdfModal(v)),
    setShouldOpenClearModal: (v) => dispatch(actions.setShouldOpenClearModal(v)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
